import type { RaspadinhaCampaign, RaspadinhaContemplatedPrizeImage } from '@/types/raspadinha-campaign'
import { withRaspadinhaExampleCampaignLabel } from './raspadinha-example-label'

const RASPADINHA_MEDIA_BASE = '/campanha-raspadinha'

/** Caminhos públicos das imagens de exemplo em `public/campanha-raspadinha/`. */
export const RASPADINHA_EXAMPLE_MEDIA = {
  welcome_image_url: `${RASPADINHA_MEDIA_BASE}/boas-vindas.jpg`,
  background_image_url: `${RASPADINHA_MEDIA_BASE}/Raspadinha.jpg`,
  contemplated_image_url: `${RASPADINHA_MEDIA_BASE}/foi-contemplado.jpg`,
  not_contemplated_image_url: `${RASPADINHA_MEDIA_BASE}/nao-contemplado.jpg`,
  contemplated_prize_vitoria: `${RASPADINHA_MEDIA_BASE}/vitoria.jpg`,
  contemplated_prize_vitoria_faca: `${RASPADINHA_MEDIA_BASE}/vitoria2.jpg`,
  regulation_pdf_url: `${RASPADINHA_MEDIA_BASE}/regulamento-campanha-raspadinha-teste.pdf`,
  cookie_policy_pdf_url: `${RASPADINHA_MEDIA_BASE}/pol%C3%ADtica-de-cookies.pdf`,
} as const

export const RASPADINHA_EXAMPLE_REGULATION_PDF_NAME =
  'regulamento-campanha-raspadinha-teste.pdf'

export const RASPADINHA_EXAMPLE_COOKIE_POLICY_PDF_NAME = 'política-de-cookies.pdf'

export const RASPADINHA_DEFAULT_PRIMARY_COLOR = '#CCA112'
export const RASPADINHA_DEFAULT_SECONDARY_COLOR = '#171717'

export const DEFAULT_CONTEMPLATED_PRIZE_EXAMPLE_ID = 'example-contemplated-prize-1'
export const DEFAULT_CONTEMPLATED_PRIZE_FACA_EXAMPLE_ID = 'example-contemplated-prize-2'

export function getDefaultRaspadinhaMediaFields(): Pick<
  RaspadinhaCampaign,
  | 'welcome_image_url'
  | 'background_image_url'
  | 'contemplated_image_url'
  | 'not_contemplated_image_url'
> {
  return {
    welcome_image_url: RASPADINHA_EXAMPLE_MEDIA.welcome_image_url,
    background_image_url: RASPADINHA_EXAMPLE_MEDIA.background_image_url,
    contemplated_image_url: RASPADINHA_EXAMPLE_MEDIA.contemplated_image_url,
    not_contemplated_image_url: RASPADINHA_EXAMPLE_MEDIA.not_contemplated_image_url,
  }
}

export function getDefaultRaspadinhaPaletteFields(): Pick<
  RaspadinhaCampaign,
  'primary_color' | 'secondary_color'
> {
  return {
    primary_color: RASPADINHA_DEFAULT_PRIMARY_COLOR,
    secondary_color: RASPADINHA_DEFAULT_SECONDARY_COLOR,
  }
}

export function createDefaultContemplatedPrizeExample(): RaspadinhaContemplatedPrizeImage {
  return {
    id: DEFAULT_CONTEMPLATED_PRIZE_EXAMPLE_ID,
    title: withRaspadinhaExampleCampaignLabel('Garfo Inox'),
    image_url: RASPADINHA_EXAMPLE_MEDIA.contemplated_prize_vitoria,
    max_contemplations: 1,
  }
}

export function createFacaInoxContemplatedPrizeExample(): RaspadinhaContemplatedPrizeImage {
  return {
    id: DEFAULT_CONTEMPLATED_PRIZE_FACA_EXAMPLE_ID,
    title: withRaspadinhaExampleCampaignLabel('Faca Inox'),
    image_url: RASPADINHA_EXAMPLE_MEDIA.contemplated_prize_vitoria_faca,
    max_contemplations: 1,
  }
}

export function getDefaultContemplatedPrizeExamples(): RaspadinhaContemplatedPrizeImage[] {
  return [createDefaultContemplatedPrizeExample(), createFacaInoxContemplatedPrizeExample()]
}

export function getDefaultRaspadinhaRegulationPdfFields(): Pick<
  RaspadinhaCampaign,
  'regulation_pdf_url' | 'regulation_pdf_name'
> {
  return {
    regulation_pdf_url: RASPADINHA_EXAMPLE_MEDIA.regulation_pdf_url,
    regulation_pdf_name: RASPADINHA_EXAMPLE_REGULATION_PDF_NAME,
  }
}

export function getDefaultRaspadinhaCookiePolicyPdfFields(): Pick<
  RaspadinhaCampaign,
  'cookie_policy_pdf_url' | 'cookie_policy_pdf_name'
> {
  return {
    cookie_policy_pdf_url: RASPADINHA_EXAMPLE_MEDIA.cookie_policy_pdf_url,
    cookie_policy_pdf_name: RASPADINHA_EXAMPLE_COOKIE_POLICY_PDF_NAME,
  }
}

export function getDefaultRaspadinhaRegulationDocumentFields(): Pick<
  RaspadinhaCampaign,
  | 'regulation_pdf_url'
  | 'regulation_pdf_name'
  | 'cookie_policy_pdf_url'
  | 'cookie_policy_pdf_name'
> {
  return {
    ...getDefaultRaspadinhaRegulationPdfFields(),
    ...getDefaultRaspadinhaCookiePolicyPdfFields(),
  }
}
